import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { WrapperComponentDirective } from '@rd-lib/whitelabel/wrapper/wrapper.component';

@Component({
  selector: 'rd-core-main-footer-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterWrapperComponent extends WrapperComponentDirective {
  @HostBinding('class.rd-core-main-footer-wrapper') componentClass = true;

  componentName = 'core-footer';

  @Input() isLoggedIn: boolean;
}
